/**
 * Le worker de synchronisation, construit ici et nulle part ailleurs.
 *
 * Isolé dans son propre module parce que `import.meta` n'existe pas pour Jest,
 * qui compile en CommonJS : les tests remplacent ce module par un double (voir
 * `jest.config`), et tout le reste de `media-sync` s'y teste normalement.
 */
export function createMediaSyncWorker(): Worker {
  return new Worker(new URL("./media-sync.worker.ts", import.meta.url), {
    type: "module",
    name: "virtuosa-media-sync",
  });
}
